import React from "react";
import { useSelector } from "react-redux";

import { withLocalizer } from "utilities/withLocalizer";
import commonUtilities from "utilities/common";
import { CONSTANTS } from "utilities/constants";
import { Icon } from "__ICON_REFERENCE__";
import EventLogo from "components/common/eventLogo";
import "./pageHeader.css";

const PageHeader = (props) => {
    const isPreview = props.isPreview || false;
    const isGeneratedQuotePage = props.isGeneratedQuotePage || false;
    const isCustomQuote = props.isCustomQuote || false;
    const showLogoIfExists = props.showLogoIfExists || false;
    const forPDF = props.forPDF || false;
    const showEventLogo = props.showEventLogo || false;
    
    const isCustomQuotePdfPage = props.isCustomQuotePdfPage || false;
    const languageCode = props.languageCode ?? commonUtilities.getLanguage();
    
    const { businessLogo } = useSelector((state) => state);
    
    let headerKey = "qma-my-group-information-header";

    if(!forPDF) {
        if(isGeneratedQuotePage) {
            headerKey = "qma-generated-quote-letter";
        }
        else {
            const user = commonUtilities.getUserType();
            const isIQMUser = commonUtilities.isIQMUser();
            
            headerKey = (isIQMUser || commonUtilities.isCalculatedQuote()) ? "qma-group-quote-header" : (user === "CUSTOMER") ? "qma-my-group-information-header" : "qma-instant-group-quote-header" ;
            
            if(isCustomQuote) {
                if(isPreview) {
                    headerKey = "qma-group-quote-preview";
                }
                else {
                    if(isCustomQuotePdfPage) {
                        headerKey = "qma-customized-group-quote";
                    }
                    else {
                        headerKey = "qma-group-quote-customization";
                    }
                }
            }
        }
    }
    
    const showBusinessLogo = !forPDF && (isCustomQuote || showLogoIfExists) && !isCustomQuotePdfPage && !isPreview && businessLogo?.data?.url;
    let pageInformation = "";
    if(isGeneratedQuotePage) {
        const infoKey = process.env.REACT_APP_BRAND + "-qma-view-quote-page-information";
        pageInformation = props.localizeByLang(infoKey, languageCode);
    }
    else {
        let informationKey = "qma-" + (commonUtilities.isCalculatedQuote() ? (process.env.REACT_APP_BRAND + "-") : "") + "my-group-vacation-page-information";
        pageInformation = isCustomQuote ? (isPreview ? props.localizeByLang("qma-preview-customized-quote-page-desc", languageCode) : props.localizeByLang("qma-custom-quote-quote-intro", languageCode)) : props.localizeByLang(informationKey, languageCode);
    }
    
    let alertMessage = isCustomQuotePdfPage ? props.localizeByLang("qma-customized-group-quote-reminding", languageCode) : props.localizeByLang("qma-" + process.env.REACT_APP_BRAND + "-my-group-vacation-page-alert", languageCode);

    return (
        <div className="page-header-container margin-bottom-1x">
            <div className={((showBusinessLogo || showEventLogo) ? "header-with-business-logo" : "")} > 
                <div className="header-information">
                    <div className="section-header">
                        <h1>
                            {props.localizeByLang(headerKey, languageCode)}
                        </h1>
                    </div>
                    {!forPDF && <div>
                        {pageInformation}
                    </div>}
                </div>
                {showBusinessLogo ? 
                    <div className="business-logo-wrapper">
                        <div className="business-logo">
                            {businessLogo?.data?.url ? 
                                <img src={businessLogo?.data?.url} alt="logo" />
                                :null
                            }
                        </div>
                    </div>
                    
                    : null
                }
                {showEventLogo && <div className="business-logo-wrapper">
                    <div className="business-logo">
                        <EventLogo languageCode={languageCode} />
                    </div>
                </div>}
            </div>
            {!forPDF && !isCustomQuote && alertMessage && <div className="row margin-top-1x notice-wrapper">
                <div className="notice-body" role="alert">
                    <div className="notice-icon"><Icon name="alert" className="icon-24" /></div>
                    <div className="notice-message">
                        {commonUtilities.parseHtml(alertMessage)}
                    </div>
                </div>
            </div>}
            
        </div>
    );
};
export default withLocalizer(PageHeader);
